/**
 * 리뷰/답글 — 활용 가이드 시나리오 단일 소스 데이터
 *
 * 새 시나리오 추가 시 이 파일에만 푸시하면 페이지에 자동 반영.
 * adminLink 는 어드민 내부 라우트 — src/routes.js 의 path 와 일치해야 함.
 */

export const REVIEW_GUIDE_SCENARIOS = [
  {
    id: 'ai-review-analysis',
    title: 'AI 리뷰 분석 활용하기',
    icon: 'cpu',
    summary: '쇼핑몰 방문자가 AI가 정리한 리뷰 핵심을 한눈에 볼 수 있도록 설정하는 방법을 단계별로 안내합니다.',
    steps: [
      {
        order: 1,
        title: '리뷰 정보 노출 설정 — AI 키워드 켜기',
        description: '리뷰 설정 페이지의 "리뷰 정보 노출 설정" 영역에서 AI 키워드 노출 옵션을 활성화합니다. 이 설정이 켜져야 위젯에서 AI 분석 결과를 보여줄 수 있습니다.',
        adminLink: '/reviewWriteConfig',
        linkLabel: '리뷰 설정 페이지로 가기'
      },
      {
        order: 2,
        title: '리뷰 인사이트 위젯 추가',
        description: 'AI가 분석한 인사이트(요약, 감성, 핵심 주제)를 보여줄 위젯을 추가하고, 어느 페이지에 노출할지 지정합니다.',
        adminLink: '/totalAiWidget',
        linkLabel: '인사이트 위젯 설정으로 가기'
      },
      {
        order: 3,
        title: 'AI 리뷰 키워드 위젯 적용',
        description: 'AI가 추출한 핵심 키워드를 칩 형태로 보여주는 위젯을 페이지에 적용해, 방문자가 한눈에 리뷰 흐름을 파악할 수 있도록 합니다.',
        adminLink: '/widgetByPage',
        linkLabel: '키워드 위젯 설정으로 가기'
      }
    ]
  }
];
